import { commonApi } from "../api/common.api";
import { CommonConfigsResponse } from "../models/Response/commonConfigResponse";
import { MasterLanguageDropdownData } from "../models/Response/masterLanguageDropdownResponse";
import { MasterSettingsListResponseData } from "../models/Response/masterSettingsListResponse";
import { UnifiedResponse } from "../models/Response/unifiedResponse";
import errorModal from "./errorModal.service";

export const commonService = {
    fetchCommonConfig: async (): Promise<UnifiedResponse<CommonConfigsResponse>> => {
        var response = await commonApi.fetchCommonConfig();
        if(!response.isSuccess)
        {
            errorModal.showErrorModal(response.statusCode, response.message);
        }
        return response;
    },

    retrieveMasterSettingsRegisterWhatsappDetail: async (): Promise<UnifiedResponse<MasterSettingsListResponseData>> => {
        var response = await commonApi.fetrieveMasterSettingsRegisterWhatsappDetailAsync();

        if (!response.isSuccess) {
          errorModal.showErrorModal(response.statusCode, response.message);
        }

        return response;
    },

    fetchMasterLanguageDropdown: async (): Promise<UnifiedResponse<MasterLanguageDropdownData>> => {
        var response = await commonApi.fetchMasterLanguageDropdown();

        if (!response.isSuccess) {
          errorModal.showErrorModal(response.statusCode,response.message,false);
        }
        return response;
    }
};